//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Make this component smart, so it forces the needed properties in order to avoid conceptual issues
export default {
  name: 'rb-board-with-fields-on',
}
